export function guardarEnStorage(data, tokenAcces, tokenRefresh,moreData) {

    sessionStorage.setItem('entidad', data.dependencia.entidad.imagen_1);
    sessionStorage.setItem('token-access', tokenAcces);
    sessionStorage.setItem('User', moreData.Email);
    sessionStorage.setItem('rol', data["dependencia"]["entidad"]["nombre"]);
    sessionStorage.setItem('dependence', data["dependencia"]["nombre"]);
    sessionStorage.setItem('dependence-id', data["dependencia"]["id"]);
    sessionStorage.setItem('user-firstName', data.first_name)
    sessionStorage.setItem('user-lastName', data.last_name)
    sessionStorage.setItem('refresh-token', tokenRefresh)
    sessionStorage.setItem('user_id', data['id'])
    sessionStorage.setItem('id-plataforma', moreData.id_plataforma)
    sessionStorage.setItem('codigo-municipio', moreData.codigo_municipio)
    sessionStorage.setItem('nombre-municipio', moreData.nombre_municipio)
    sessionStorage.setItem('nombre-plataforma',moreData.nombre_plataforma)
    //Datos de geoserver
    sessionStorage.setItem('geo-url',data["otro_insumos"]["GEOSERVER_URL"])
    sessionStorage.setItem('geo-store',data["otro_insumos"]["GEOSERVER_STORE"])
    sessionStorage.setItem('geo-wms-key',data["otro_insumos"]["GEOSERVER_WMS_KEY"])
    sessionStorage.setItem('geo-wfs-key',data["otro_insumos"]["GEOSERVER_WFS_KEY"])
}